<div class="page-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Clients</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="controls-container">
        <mat-button-toggle-group [value]="activeClientType" (change)="selectClientType($event.value)">
          <mat-button-toggle [value]="ClientType.Company">Company Clients</mat-button-toggle>
          <mat-button-toggle [value]="ClientType.LightEntrepreneur">Light Entrepreneur Clients</mat-button-toggle>
        </mat-button-toggle-group>

        <mat-form-field class="search-field">
          <input matInput placeholder="Search..." [formControl]="searchControl">
        </mat-form-field>
      </div>

      <div class="table-container">
        <table mat-table [dataSource]="clients$" class="mat-elevation-z8">

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let client"> {{getName(client)}} </td>
          </ng-container>

          <!-- ID Number Column -->
          <ng-container matColumnDef="id_number">
            <th mat-header-cell *matHeaderCellDef> {{ getClientIdHeader() }} </th>
            <td mat-cell *matCellDef="let client"> {{ getClientIdValue(client) }} </td>
          </ng-container>

          <!-- Invoicing Service Company Business ID Column -->
          <ng-container matColumnDef="invoicing_service_company_business_id">
            <th mat-header-cell *matHeaderCellDef fxHide.lt-xl> Invoicing Service Co. ID </th>
            <td mat-cell *matCellDef="let client" fxHide.lt-xl> {{ getInvoicingServiceCompanyBusinessId(client) }} </td>
          </ng-container>

          <!-- Country Column -->
          <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef fxHide.lt-md> Country </th>
            <td mat-cell *matCellDef="let client" fxHide.lt-md> {{getCountry(client)}} </td>
          </ng-container>

          <!-- Responsible Seller Column -->
          <ng-container matColumnDef="responsible_seller">
            <th mat-header-cell *matHeaderCellDef fxHide.lt-lg> Responsible Seller </th>
            <td mat-cell *matCellDef="let client" fxHide.lt-lg> {{ getResponsibleSellerName(client) }} </td>
          </ng-container>

          <!-- Created At Column -->
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef fxHide.lt-lg> Created </th>
            <td mat-cell *matCellDef="let client" fxHide.lt-lg> {{ getCreatedAt(client) | date:'shortDate' }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable-row" (click)="viewClient(row)"></tr>
        </table>
      </div>

    </mat-card-content>
  </mat-card>
</div>
